/**
 * Aperçu compact du Score BoG 2026 (TIF/VPC/cVPC/HazID) affiché sur le
 * Cockpit principal, avec lien vers la page de détail "/score-bog"
 * (répartition par site + Encadrement/Maîtrise Opérationnelle).
 */
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { SCORE } from "@/constants/testIds";

const METRICS = [
  { key: "tif_pct", label: "TIF" },
  { key: "vpc_pct", label: "VPC" },
  { key: "cvpc_pct", label: "cVPC" },
  { key: "hazid_pct", label: "HazID" },
];

function toneFor(pct) {
  if (pct == null) return "text-slate-400";
  if (pct < 70) return "text-red-600";
  if (pct < 90) return "text-amber-600";
  return "text-emerald-600";
}

export default function BogScoreCard({ bogScore }) {
  const values = bogScore?.sites?.length === 1 ? bogScore.sites[0] : bogScore?.company_average;
  const label = bogScore?.sites?.length === 1 ? bogScore.sites[0].site : "Moyenne LP Ciments";

  return (
    <Card data-testid={SCORE.container} className="flex h-full flex-col border-slate-200 p-5 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Score BoG 2026</p>
      <p data-testid="bog-score-card-label" className="mt-0.5 truncate text-xs text-slate-400">{label}</p>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {METRICS.map((m) => (
          <div key={m.key} data-testid={`bog-score-card-${m.key}`} className="rounded-md bg-slate-50 p-2.5 text-center">
            <p className="text-[10px] font-medium uppercase tracking-wider text-slate-400">{m.label}</p>
            <p className={`text-xl font-bold tabular-nums ${toneFor(values?.[m.key])}`}>{values?.[m.key] ?? "-"}%</p>
          </div>
        ))}
      </div>
      <Link
        to="/score-bog"
        data-testid="bog-score-card-detail-link"
        className="mt-4 flex items-center justify-center gap-1.5 rounded-md border border-slate-200 py-2 text-xs font-medium text-[#0B5394] transition-colors hover:bg-slate-50"
      >
        Voir le détail par site <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </Card>
  );
}
